import { useEffect, useState } from 'react';

const LAST_KNOWN_POSITION_THRESHOLD_MS = 30 * 60 * 1000;

export const useIsLastKnownPosition = (timestamp: string | null | undefined, enabled: boolean): boolean => {
  const [isLastKnownPosition, setIsLastKnownPosition] = useState(false);

  useEffect(() => {
    if (!enabled || !timestamp) {
      setIsLastKnownPosition(false);
      return undefined;
    }

    const positionTimestamp = Date.parse(timestamp);

    if (Number.isNaN(positionTimestamp)) {
      setIsLastKnownPosition(false);
      return undefined;
    }

    const updatePositionState = () => {
      const positionAge = Date.now() - positionTimestamp;

      setIsLastKnownPosition(positionAge >= LAST_KNOWN_POSITION_THRESHOLD_MS);
    };

    updatePositionState();

    const staleAt = positionTimestamp + LAST_KNOWN_POSITION_THRESHOLD_MS;
    const timeUntilStale = staleAt - Date.now();

    if (timeUntilStale <= 0) {
      return undefined;
    }

    const timeoutId = window.setTimeout(updatePositionState, timeUntilStale + 100);

    return () => window.clearTimeout(timeoutId);
  }, [enabled, timestamp]);

  return isLastKnownPosition;
};
